import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

interface IProps {
    content: ReactNode;
    hideToast?: () => void;
}

export default function LicenseAlertToast({ content, hideToast }: IProps) {
    const { t } = useTranslation();

    return (
        <div className="notificationContentContainer">
            {content}
            <div className="notificationHideActions">
                <div />
                <a href="#" onClick={hideToast}>
                    {t("Error.hide")}
                </a>
            </div>
        </div>
    );
}
